import { render } from "./dentrion_why.vue?vue&type=template&id=735882e0&scoped=true"
import script from "./dentrion_why.vue?vue&type=script&lang=js"
export * from "./dentrion_why.vue?vue&type=script&lang=js"

import "./dentrion_why.vue?vue&type=style&index=0&id=735882e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735882e0"]])

export default __exports__